export default __webpack_public_path__ + "static/ISP_kolor-99a335461b202e919397223fb10f70e4.jpg";